import { object } from 'yup';
import { TFunction } from 'i18next';

import { requiredEmailField, requiredVerificationCodeField } from 'common/validation';

export function makeEmailSchema(t: TFunction) {
  return object().shape({
    email: requiredEmailField(t),
  });
}

export function makeCodeSchema(t: TFunction) {
  return object().shape({
    code: requiredVerificationCodeField(t),
  });
}
